export default "__VITE_ASSET__DnvZHK0w__"